import React from 'react';
import PropTypes from 'prop-types';
import './ScriptGeneratorControlPanel.css';

const ScriptGeneratorControlPanel = ({
  selectedTechnology,
  setSelectedTechnology,
  isGenerating,
  generateScripts,
  currentBatch,
  totalBatches
}) => (
  <div className="control-panel">
    {/* Technology Selection Section */}
    <div className="control-section">
      <div className="control-section-title">Script Technology</div>
      <div className="technology-selection-section">
        <label>Select Technology:</label>
        <select
          value={selectedTechnology}
          onChange={(e) => setSelectedTechnology(e.target.value)}
          className="technology-select"
        >
          <option value="informatica">🔄 Informatica</option>
          <option value="pyspark">⚡ PySpark</option>
        </select>
      </div>
    </div>
    {/* Main Action Section */}
    <div className="control-section">
      {/* <div className="control-section-title">Generate Scripts</div> */}
      <div className="control-buttons">
        <button
          onClick={generateScripts}
          disabled={isGenerating}
          className="btn-primary"
          style={{ background: '#093878' }}
              
        >
          {isGenerating ? 'Generating Scripts...' : 'Generate Transformation Scripts'}
        </button>
      </div>
    </div>
    {/* Progress Indicator */}
    {isGenerating && (
      <div className="progress-container">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(currentBatch / totalBatches) * 100}%` }}
          ></div>
        </div>
        <p>Processing batch {currentBatch} of {totalBatches}</p>
      </div>
    )}
  </div>
);

ScriptGeneratorControlPanel.propTypes = {
  selectedTechnology: PropTypes.string.isRequired,
  setSelectedTechnology: PropTypes.func.isRequired,
  isGenerating: PropTypes.bool.isRequired,
  generateScripts: PropTypes.func.isRequired,
  currentBatch: PropTypes.number.isRequired,
  totalBatches: PropTypes.number.isRequired
};

export default ScriptGeneratorControlPanel; 